export const projectFrag = `
    id
    name
    code
    description
    dateFrom
    dateTo
`;
